export default "__VITE_ASSET__2e805d28__"